export async function filterPreparation(
  filters_list,
  storage,
  pipeService,
  variables = {}
) {
  const filterArray = [];

  const objectMethod = {
    variableMethodcurrent_app() {
      return [variables.current_app_id || variables.app_id];
    },
    variableMethodelement_app() {
      return [variables.element_app_id];
    },

    variableMethodcurrent_item() {
      const currentValue = `${variables.current_app_id || variables.app_id}.${variables.item_id}`;
      return [currentValue];
    },

    variableMethoduser_id() {
      const storage_user = storage.getUser();
      return [storage_user.user_id];
    },

    variableMethoduser_email(filter) {
      const storage_user = storage.getUser();
      return [storage_user.username];
    },

    variableMethodtoday(filter) {
      const date = new Date();
      const start_date = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate()
      );
      const end_date = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() + 1
      );
      const result =
        start_date.valueOf().toString() + ":" + end_date.valueOf().toString();
      return [result];
    },
    variableMethodvariable(property) {
      return [variables[property]];
    },
  };
  if (filters_list) {
    for (const filter of filters_list) {
      if (filter) {
        // ---------------------- WARNING !!! -------------------------------
        // Should be fixed: modification of filters_list valuesArray
        switch (filter.input_type) {
          case "variable":
            filter.valuesArray = [];
            for(const filterValue of filter?.input_value.split(',')) {
              const functionName =
                filter.input_type + "Method" + filterValue;
              const func = objectMethod[functionName];
              if (typeof func === "function") {
                if(!filter.valuesArray) {
                  filter.valuesArray = func();
                } else {
                  filter.valuesArray.push(...func());
                }
              } else {
                if(!filter.valuesArray) {
                  filter.valuesArray = objectMethod.variableMethodvariable(filterValue);
                } else {
                  filter.valuesArray.push(...objectMethod.variableMethodvariable(filterValue));
                }
              }
            }
            filterArray.push(filter);
            break;
          case "field":
            const field_value = await fieldMethod({
              app_id: variables.current_app_id || variables.app_id,
              item_id: variables.item_id,
              field_id: filter.input_value,
            });
            if(field_value != null){
              filter.valuesArray.push(field_value)
            }
            filterArray.push(filter);
            break;
          default:
            filterArray.push(filter);
            break;
        }
      } else {
        filterArray.push(filter);
      }
    }
  }

  function fieldMethod(address) {
    return new Promise((resolve) => {
      pipeService
        .on("gh_value_get", address, function ghValueGet(event, field_value) {
          pipeService.destroy("gh_value_get", address, ghValueGet);
          resolve(field_value);
        })
        .emit("gh_value_get", {}, address);
    });
  }

  return filterArray;
}
